<template>
  <div class="container-fluid pt-section-fix" id="modules">
    <div class="row position-relative">
      <div class="col-12 col-md-3 col-xl-2 section-main-title">
        <div class="d-block d-md-inline-block main-background">МОДУЛИ</div>
      </div>
      <div class="col-12 col-md-9 col-xl-10 text-justify">
        <p class="mb-0">
          Електронна <strong>платформа АдминПлюс</strong> е двустранно интегрирана с Националната електронна информационна система за предучилищно и училищно образование (НЕИСПУО) 
          и използва данните, въведени в <strong>списък-образец 1, 2 или 3:</strong>
        </p>
        <ul>
          <li>институция;</li>
          <li>учебния план;</li>
          <li>паралелки и ученици;</li>
          <li>групи и деца;</li>
          <li>служители и годишната преподавателска заетост.</li>
        </ul>
        <p>
          Данните <strong>могат да бъдат прехвърляни към платформата</strong>, когато е
          <strong>необходимо</strong>, от <strong>определеното за това лице</strong> в образователната институция.
        </p>
        <p>
          Това <strong>гарантира пълно съответствие</strong> на данните за <strong>списък-образец 1, 2 или
          3</strong> с тези в <strong>платформата АдминПлюс</strong>.
        </p>
      </div>

      <div class="col-12 col-md-3 col-xl-2 section-sub-title mb-4">
        <div class="d-block d-md-inline-block main-background">УЧИЛИЩА</div>
      </div>
      <div class="col-12 col-md-9 col-xl-10 mb-4">
        <div class="row">
          <div class="col-12 col-xl-6" v-for="(singleRow, index) in schoolsData" :key="`school${index}`">
            <modules-single-component :data="singleRow"></modules-single-component>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-3 col-xl-2 section-sub-title two-rows mb-4">
        <div class="d-block d-md-inline-block main-background">ЦСОП</div>
      </div>
      <div class="col-12 col-md-9 col-xl-10 mb-4">
        <div class="row">
          <div class="col-12 col-xl-6" v-for="(singleRow, index) in csopData" :key="`csop${index}`">
            <modules-single-component :data="singleRow"></modules-single-component>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-3 col-xl-2 section-sub-title two-rows mb-4">
        <div class="d-block d-md-inline-block main-background">ЦПЛР</div>
      </div>
      <div class="col-12 col-md-9 col-xl-10 mb-4">
        <div class="row">
          <div class="col-12 col-xl-6" v-for="(singleRow, index) in cplrData" :key="`cplr${index}`">
            <modules-single-component :data="singleRow"></modules-single-component>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-3 col-xl-2 section-sub-title two-rows mb-4">
        <div class="d-block d-md-inline-block main-background">ДЕТСКИ<br>ГРАДИНИ</div>
      </div>
      <div class="col-12 col-md-9 col-xl-10 mb-4">
        <div class="row">
          <div class="col-12 col-xl-6" v-for="(singleRow, index) in kindergartenData" :key="`kindergarten${index}`">
            <modules-single-component :data="singleRow"></modules-single-component>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-3 col-xl-2 section-sub-title two-rows mb-4">
        <div class="d-block d-md-inline-block main-background">УЧЕНИЦИ И<br>РОДИТЕЛИ</div>
      </div>
      <div class="col-12 col-md-9 col-xl-10 mb-4">
        <div class="row">
          <div class="col-12 col-xl-6" v-for="(singleRow, index) in parentsData" :key="`parents${index}`">
            <modules-single-component :data="singleRow"></modules-single-component>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-3 col-xl-2 section-sub-title two-rows mb-4">
        <div class="d-block d-md-inline-block main-background">ANDROID<br>
          iOS
        </div>
      </div>
      <div class="col-12 col-md-9 col-xl-10">
        <div class="row">
          <div class="col-12 col-xl-6">
            <div class="info-box passive info-box-big d-flex mb-3">
              <div class="info-box-title info-box-img-link">
                <a href="https://apps.apple.com/us/app/a-adminplus/id1592313690"
                   target="_blank">
                  <qr-ios-icon></qr-ios-icon>
                </a>
              </div>
              <div class="info-box-content">
                <div class="align-items-center d-flex h-100 info-box-head">
                  <h3>
                    <a href="https://apps.apple.com/us/app/a-adminplus/id1592313690"
                       target="_blank"
                       class="info-box-link">
                      <font-awesome-icon :icon="['fab', 'app-store-ios']"></font-awesome-icon>&nbsp;&nbsp;iOS</a>
                  </h3>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-6">
            <div class="info-box passive info-box-big d-flex mb-3">
              <div class="info-box-title info-box-img-link">
                <a href="https://play.google.com/store/apps/details?id=bg.adminplus.mbl"
                   target="_blank">
                  <qr-android-icon></qr-android-icon>
                </a>
              </div>
              <div class="info-box-content">
                <div class="align-items-center d-flex h-100 info-box-head">
                  <h3>
                    <a href="https://play.google.com/store/apps/details?id=bg.adminplus.mbl"
                       target="_blank"
                       class="info-box-link">
                      <font-awesome-icon :icon="['fab', 'google-play']"></font-awesome-icon>&nbsp;&nbsp;Android</a>
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModulesSingleComponent from './modules-single-component'
import { schoolsData } from './data/schools'
import { kindergartenData } from './data/kindergarten'
import { parentsData } from './data/parents'
import QrAndroidIcon from './icons/qr-android-icon'
import QrIosIcon from './icons/qr-ios-icon'
import { csopData } from './data/csop'
import { cplrData } from './data/cplr'

export default {
  name: 'modules-component',
  components: { QrIosIcon, QrAndroidIcon, ModulesSingleComponent },
  data () {
    return {
      schoolsData: schoolsData,
      kindergartenData: kindergartenData,
      parentsData: parentsData,
      csopData: csopData,
      cplrData: cplrData
    }
  },
}
</script>

<style scoped>
.qr-image {
  width: 100px;
}
</style>
